import type { EventEmitter } from '@stencil/core';
import { Component, Event, Host, Prop, h } from '@stencil/core';

/**
 * @slot - Slot for adding dialog title content. Only works if property dialogTitle is undefined.
 */
@Component({
  tag: 'sy-dialog-header',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class DialogHeader {
  /**
   * Title to be displayed in the dialog.
   */
  @Prop() dialogTitle: string;

  /**
   * Defines if the dialog close button will be displayed.
   */
  @Prop({ reflect: true }) hideCloseButton = false;

  /**
   * Event to indicate the click on the dialog-header close button.
   */
  @Event({ cancelable: false }) syDialogHeaderDidCloseClick: EventEmitter<void>;

  render() {
    return (
      <Host>
        <div id="title-for-aria" class="sy-dialog-title">
          {this.dialogTitle ? this.dialogTitle : <slot></slot>}
        </div>
        {!this.hideCloseButton && (
          <sy-dismiss class="sy-dismiss" large onClick={() => this.syDialogHeaderDidCloseClick.emit()}></sy-dismiss>
        )}
      </Host>
    );
  }
}
